import React from 'react';
import framework from 'utils/framework';
import useRoktPageView from 'hooks/useRoktPageView';
const { wrapFunctionalComponent } = framework;

import AccountInfo from 'components/RichProfile/MyAccount/AccountInfo/AccountInfo';
import ufeApi from 'services/api/ufeApi';

const MyAccount = () => {
    useRoktPageView({ pagetype: 'MyAccount', screenname: 'My Account', title: 'My Account' });

    return (
        <div>
            <AccountInfo requestCounter={ufeApi.getCallsCounter()} />
        </div>
    );
};

export default wrapFunctionalComponent(MyAccount, 'MyAccount');
